import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { InsuranceService } from '../_services/insurance.services';
import { DocumentService } from '../_services/document.services';
import { InterestService } from '../_services/interest.services';
import { HelperServices } from '../_services/helper.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Policy } from '../_models/policy.model';
import { Document } from '../_models/document.model';
import { Interest } from '../_models/interest.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

declare var require: any
const FileSaver = require('file-saver');

declare var download: any;

import {
  GroupingState,
  PaginatorState,
  SortState,
  ICreateAction,
  IEditAction,
  IDeleteAction,
  IDeleteSelectedAction,
  IFetchSelectedAction,
  IUpdateStatusForSelectedAction,
  ISortView,
  IFilterView,
  IGroupingView,
  ISearchView,
} from '../../_metronic/shared/crud-table';

@Component({
  selector: 'app-list-insurance',
  templateUrl: './list-insurance.component.html',
  styleUrls: ['./list-insurance.component.scss']
})

export class ListInsuranceComponent implements
OnInit, 
OnDestroy {
  loadingModalConfig: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  loadingModal: boolean = false;
  paginator: PaginatorState;
  sorting: SortState;
  grouping: GroupingState;
  isLoading: boolean;
  templateView: number = 1;
  idPoliza: number = 0;
  idDocument: number = 0;
  idEntity: number = 0;
  insuredFilter: number = 0;
  policy_selected: Policy;
  document_selected: Document;
  documents_policy: Document[];
  interest_selected: Interest;
  showComapnyName: boolean = false;
  extrasUserDropdownStyle: 'light' | 'dark' = 'light';
  user$: Observable<UserModel>;
  _user: UserModel;
  hasError: boolean;
  ramos: any;
  subramos: any;
  anyos: any;
  meses: any;
  endosos: any;
  companies: any;
  tiposEndosos;
  filterPolicyForm: FormGroup;
  interestForm: FormGroup;
  endosoForm: FormGroup;
  endosoHasError: boolean;
  inputIdTipoEndoso: boolean;
  closeResult: string;
  activeSubmitFilterPolicy: boolean = false;
  IdRamo: boolean = false;
  templatePostEndoso: number = 1;
  tipoFiltroInteres: any;
  resultPostEndosoMessage: string;
  detalleInteresAsegurado: any;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  permissionMenu: any;
  config: any;

  constructor(
    public insuranceService: InsuranceService,
    public documentService: DocumentService,
    public interestService: InterestService,
    private layout: LayoutService,
    private auth: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private modalLoading: NgbModal,
    public sanitizer: DomSanitizer,
    public helperServices: HelperServices
  ) {}

  // angular lifecircle hooks
  async ngOnInit() {
    this.config = JSON.parse(localStorage.getItem("remote_params"));

    this.initForm();

    this.extrasUserDropdownStyle = this.layout.getProp(
      'extras.user.dropdown.style'
    );
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.user$.subscribe(user=> {
      this._user = user;
     });


    this.insuranceService.fetch();
    this.paginator = this.insuranceService.paginator;

    this.ramos = this.insuranceService.getRamos();
    this.meses = this.insuranceService.getMeses();
    this.anyos = this.insuranceService.getAnyos();
    this.companies = this.helperServices.getCompaniaSeguros();
    this.tipoFiltroInteres = this.helperServices.getTipoFiltroInteres();
    //this.tiposEndosos = this.insuranceService.getAnyos();

    const sb1 = this.insuranceService.isLoading$.subscribe(res => this.isLoading = res);
    this.subscriptions.push(sb1);
    this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];


  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  async clickView(id = 0, _templateView) {
    var _this = this;
    if(!id){
      return false;
    }
    else {
      switch ((this.templateView = _templateView)) {
        case 1:
          this.templateView = _templateView;
          break;
        case 2:
          this.idPoliza = id;
          this.policy_selected = this.insuranceService.extracData(this.idPoliza, this.insuranceService.items$);
          this.documentService.patchState({paramsGet : Array(`IdPoliza=${this.idPoliza}`).join('&')});
          console.log(this.policy_selected);
          break;
        case 3:
          this.policy_selected = this.insuranceService.extracData(id, this.insuranceService.items$);
          this.interestService.patchState({paramsGet : Array(`IdTipoFiltro=`,`Texto=`,`IdPoliza=${this.idPoliza}`).join('&')});
          var filtro = {
            IdTipoFiltro : 1,
            Texto: "",
            IdEstatus: 1
          }
          //this.interestService.patchState({paramsGet : Array(`IdTipoFiltro=${this.idPoliza}`, `Texto=${filtro.Texto}`,`IdEstatus=${filtro.IdEstatus}`).join('&')});
          this.templateView = _templateView;
          break;
      }
    }
  }

  clickGetEndoso(content, idPoliza) {
    this.endosos = this.insuranceService.getEndosos("IdPoliza=" + idPoliza);
    this.policy_selected = this.insuranceService.extracData(idPoliza, this.insuranceService.items$);
    this.endosoForm.patchValue({ "inputIdPoliza" : idPoliza });
    this.modalService.open(content, this.loadingModalConfig).result.then((result) => {
        
      }, (reason) => { // ESC, BACKDROP_CLICK
          
      });
  }

  clickDownloadEstatement(content, IdPoliza) {
    this.modalLoading.open(content, this.loadingModalConfig);
    this.documentService.getPolicyEstatement("IdPoliza="+IdPoliza).then((res) => {

      this.helperServices.printPreview(res[0].Documento, res[0].NombreDocumento, "application/pdf");

    }).finally(() => {
      this.modalLoading.dismissAll();
    })
  }

  

  d(text) {

  }
 
  async clickDownloadDocument(content, id, filename, event) {
    //event.currentTarget.disabled = true;
    this.modalLoading.open(content, this.loadingModalConfig);

    var base64String = await this.documentService.get_documents_by(Array(`IdDocumento=${id}`).join('&')).then( (base64String) => {
      const linkSource = `data:application/pdf;base64,${base64String}`;
      const downloadLink = document.createElement("a");
  
      downloadLink.href = linkSource;
      downloadLink.download = filename;
      downloadLink.click();
    }).finally(() => {
      this.modalLoading.dismissAll();
    });
    /*
    const source = `data:application/pdf;base64,${base64String}`;
    let pdfWindow = window.open("");
    pdfWindow.document.write("<iframe width='100%' height='100%' src='" + source + "'></iframe>");
    */
  }

  downloadPolicyGeneralCondition(content) {
    this.modalLoading.open(content, this.loadingModalConfig);

    this.documentService.getPolicyGeneralCondition("IdPoliza="+this.idPoliza).then((res) => {
      
      this.helperServices.printPreview(res[0].Documento, res[0].NombreDocumento, "application/pdf");

    }).finally(() => {
      this.modalLoading.dismissAll();
    })
  }

  changeFilterMode(event) {
    this.insuredFilter = event.target.value;
  }

  changeRamo(event) {
    this.subramos = this.insuranceService.getSubRamos("IdRamo=" + event.target.value).finally(() => {
      this.IdRamo = event.target.value > 0 ? event.target.value : false;
    });
  }

  initForm() {

    this.filterPolicyForm = this.fb.group({
      inputMes: [''],
      inputAnyo: [''],
      inputRamo: [''],
      inputSubRamo: [''],
      inputNroDePoliza: [''],
      inputAsegurado: [''],
      inputPlaca: [''],
      inputIdentificacion: [''],
      inputIdCompania: [''],
      inputGrupoEconomico: ['']
    });

    this.endosoForm = this.fb.group({
      inputObservacion: [''],
      inputIdPoliza: [''],
      inputIdTipoEndoso: ['', Validators.compose([Validators.required]) ],
      file1: ['',  Validators.compose([Validators.required])],
    });

    this.interestForm = this.fb.group({
      insured_filter_mode : [
        1,
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
        ]),
      ],
      insured_filter_mode_1: [
        '',
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      insured_filter_mode_2: [
        '',
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      insured_filter_mode_3: [
        '',
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
    });
  }

  submitFilterPolicy(content) {
    //this.modalLoading.open(content, this.loadingModalConfig);
    
    var paramsGet = Array( 
        `IdEntidad=${this._user.id}`,
        `Asegurado=${this.filterPolicyForm.value.inputAsegurado || ''}`,
        `IdRamo=${this.filterPolicyForm.value.inputRamo || ''}`,
        `IdSubRamo=${this.filterPolicyForm.value.inputSubRamo || ''}`,
        `IdMes=${this.filterPolicyForm.value.inputMes || ''}`,
        `IdAno=${this.filterPolicyForm.value.inputAnyo || ''}`,
        `NroDePoliza=${this.filterPolicyForm.value.inputNroDePoliza || ''}`,
        `Identificacion=${this.filterPolicyForm.value.inputIdentificacion || ''}`,
        `Placa=${this.filterPolicyForm.value.inputPlaca || ''}`
    )

    if(this.permissionMenu.VerGrupoEconomico == 1) {
      paramsGet.push(`GrupoEconomico=${this.filterPolicyForm.value.inputGrupoEconomico || ''}`);
    }

    if(this.permissionMenu.VerCompania == 1) {
        paramsGet.push(`IdCompania=${this.filterPolicyForm.value.inputIdCompania || ''}`);
      }

    this.insuranceService.patchState({ paramsGet : paramsGet.join('&') });
  } 

  submitEndoso(resultPostEndoso) {
    this.endosoHasError = false;
    this.templatePostEndoso = 2;

    if(this.endosoForm.valid) {
      this.modalService.dismissAll();
      // 
      this.insuranceService.postEndoso({
        "IdPoliza" : this.endosoForm.value.inputIdPoliza,
        "IdTipoEndoso" : this.endosoForm.value.inputIdTipoEndoso,
        "Observacion": this.endosoForm.value.inputObservacion,  
      }, resultPostEndoso.target.file1).then( (response) =>{
        if(typeof response[0].Mensaje != undefined && response[0].Mensaje == "Solicitud generada") {
          this.templatePostEndoso = 3;
          //if( response[0].Mensaje == "Solicitud generada") {
            alert(response[0].Mensaje);
          //}
        } else {
          alert("No se pudo enviar la solicitud.")
        }
      })
      
      
      /*.then((e) => {
          
      }).finally(() => {
        this.modalService.dismissAll();
      }).finally(() => {
        alert("Solicitud enviada");
      });*/
    }else {
      this.endosoHasError = true;
    }
  }

  resetSubmitFilterPolicy() {
    this.filterPolicyForm.reset( {"inputNroDePoliza" : ""} );
  }

  submitFilterInterest() {
    var s = "";
    var paramsGet = [];
    paramsGet.push(`IdTipoFiltro=${this.interestForm.value.insured_filter_mode}`);
    paramsGet.push(`IdPoliza=${this.idPoliza}`);

    switch(parseInt(this.interestForm.value.insured_filter_mode)) {
      case 1:
        s = this.interestForm.value.insured_filter_mode_1; // Descrip
        paramsGet.push(`Texto=${s}`);
      break;
      case 2:
        s = this.interestForm.value.insured_filter_mode_2; // Nro Certificado
        paramsGet.push(`Texto=${s}`);
      break;
      case 3:
        s = this.interestForm.value.insured_filter_mode_3; // Estado
        paramsGet.push(`Texto=${s}`);
      break;
    };

    this.interestService.patchState({paramsGet : paramsGet.join('&')});
  }


  // pagination
  paginate(paginator: PaginatorState) {
    this.insuranceService.patchState({ paginator });
  }

  onclickModalInteresAsegurado(content, item, id) {
    this.loadingModal= true;

    this.modalService.open(content,  {size: 'lg'} ).result.then((result) => {
      console.log(result)
    }, (reason) => { // this.getDismissReason(reason)
        
    });

    console.log(this.detalleInteresAsegurado = item);
    this.loadingModal = false;
    /*
    this.interestService.extracData(id, this.interestService.items$).finally(() => {
      this.loadingModal = false;
    });    
    */
  }
}
